// This file is kept for backward compatibility with existing imports.
// Please import from the index.js or specific module files instead.

import spApi from './coreSpApi';
export { spApi };
export { spPackageApi } from './spPackageApi';
export { spPhotoApi } from './spPhotoApi';
export { spBidApi } from './spBidApi';
export { spSearchApi } from './spSearchApi';
export { serviceCategoryApi } from './serviceCategoryApi';

export default spApi;